import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import DragCarousel from './components/DragCarousel';

const LEFT_ARROW = 'left_arrow';

const DragCarouselContainer = (props) => {
  const { children, gap, arrows, indicators, arrowDraggable } = props;
  const className = 'c-DragCarouselContainer';

  const slider = useRef(null);
  let isDown = useRef(false);
  let startX = useRef(null);
  let scrollLeft = useRef(null);
  let rightArrow = useRef(null);
  let leftArrow = useRef(null);
  let [indicatorCount, setIndicatorCount] = useState(0);
  let [activeIndicator, setActiveIndicator] = useState(0);

  const handleIndicatorClick = (index) => {
    slider.current.scroll({
      left: slider.current.clientWidth * index,
      behavior: 'smooth',
    });
    setActiveIndicator(index);
  };

  const handleArrowClick = (type) => {
    let offsetValue = type === LEFT_ARROW ? -arrowDraggable : arrowDraggable;
    slider.current.scrollBy({
      left: offsetValue,
      behavior: 'smooth',
    });
  };

  const initializeValues = (e) => {
    isDown.current = true;
    startX.current = e.pageX - slider.current.offsetLeft;
    scrollLeft.current = slider.current.scrollLeft;
  };

  const calculateDragValue = (e) => {
    if (!isDown.current) return;
    e.preventDefault();
    const x = e.pageX - slider.current.offsetLeft;
    const walk = x - startX.current;
    slider.current.scrollLeft = scrollLeft.current - walk;
  };

  const findActiveIndicator = () => {
    let activeIndex = Math.ceil(
      slider.current.scrollLeft / slider.current.clientWidth
    );
    setActiveIndicator(activeIndex);
  };

  const hideArrows = () => {
    findActiveIndicator();
    if (arrows) {
      let scrollLeftVal = slider.current.scrollLeft;
      let offsetLeftVal =
        slider.current.scrollWidth - slider.current.clientWidth;

      if (scrollLeftVal <= 0) {
        leftArrow.current.style.display = 'none';
      } else {
        leftArrow.current.style.display = 'grid';
      }

      if (scrollLeftVal >= offsetLeftVal) {
        rightArrow.current.style.display = 'none';
      } else {
        rightArrow.current.style.display = 'grid';
      }
    }
  };

  useEffect(() => {
    const clearValue = () => {
      isDown.current = false;
      findActiveIndicator();
    };

    if (slider && slider.current) {
      let sliderRef = slider.current;
      let indicatorCountVal = Math.ceil(
        sliderRef.scrollWidth / sliderRef.clientWidth
      ); //To find the number of indicators required (totalLengthOfList / visibleLengthOfList)
      setIndicatorCount(indicatorCountVal || 0);

      sliderRef.addEventListener('mousedown', initializeValues);
      sliderRef.addEventListener('mouseup', clearValue);
      sliderRef.addEventListener('mousemove', calculateDragValue);
      sliderRef.addEventListener('scroll', hideArrows);

      return () => {
        sliderRef.removeEventListener('mousedown', initializeValues);
        sliderRef.removeEventListener('mouseup', clearValue);
        sliderRef.removeEventListener('mousemove', calculateDragValue);
        sliderRef.addEventListener('scroll', hideArrows);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={className}>
      <DragCarousel
        activeIndicator={activeIndicator}
        handleIndicatorClick={handleIndicatorClick}
        indicatorCount={indicatorCount}
        handleArrowClick={handleArrowClick}
        gap={gap}
        arrows={arrows}
        indicators={indicators}
        ref={{
          sliderRef: slider,
          leftArrowRef: leftArrow,
          rightArrowRef: rightArrow,
        }}
        childrens={children}
      />
    </div>
  );
};

DragCarouselContainer.propTypes = {
  gap: PropTypes.number,
  arrows: PropTypes.bool,
  indicators: PropTypes.bool,
  arrowDraggable: PropTypes.number,
};

DragCarouselContainer.defaultProps = {
  arrows: false,
  indicators: false,
  arrowDraggable: 500,
};

export default DragCarouselContainer;
